import { Validator } from 'fluentvalidation-ts';
import { MealCountVersionValidator, ReceivedMealsSoftValidator, ServingLineValidator } from '@/models';
import { MealCountDtoViewModel } from '@/view-models';

export class MealCountSoftValidator extends Validator<MealCountDtoViewModel> {
  constructor() {
    super();
    
    this.ruleFor('mealCounts')
    .setValidator(() => new MealCountVersionValidator());

    this.ruleFor('receivedMeals')
      .setValidator(() => new ReceivedMealsSoftValidator());

    this.ruleFor('userServingLine')
      .setValidator(m => new ServingLineValidator());
  }
}
